import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Badge } from '../../material-ui/Badge';
import { Comment } from '../../../icons';
import { useMessengerAllowed, useMessengerSidebarUnreadCount } from '../../../selectors/messenger';
import { useStyles } from './useStyles';

export const MessengerAdapter = memo(({ value, selected, onClick, className }) => {
    const isAllowed = useMessengerAllowed();
    const unread = useMessengerSidebarUnreadCount();

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick, value]);

    if (!isAllowed) {
        return null;
    }

    return (
        <ListItem onClick={handleClick} button={true} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Badge badgeContent={unread} color="secondary" max={999} classes={{ anchorOriginTopRightRectangular: classes.badge }}>
                    <Comment width="24" height="24" />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={translate('labels.messages')} className={className} />
        </ListItem>
    );
});

MessengerAdapter.displayName = 'MessengerAdapter';
